<script setup>
  import { ref, onMounted, watch, watchEffect, computed } from 'vue';
  import { useUserStore } from '@/stores/UserStore';
  import { useUpdateKey } from '@/composables/useUpdateKey';
  import SpotList from '@/components/SpotList.vue';
  import useSettingsGlobals from '@/composables/useSettingsGlobals';

  const { $ADS_ALLOWED } = useSettingsGlobals();

  const emit = defineEmits(['loaded', 'detail', 'spotListSorted']);

  const userStore = useUserStore();
  const updateKey = useUpdateKey()

  const isLoading = ref(true);

  const showAds = computed(() => $ADS_ALLOWED && (userStore.showAds || userStore.memberLevel < 46));
  const spotCount = computed(() => userStore.favoriteSpotData.spots?.length ?? 0);
  const adCount = computed(() => {
    if (!showAds.value || spotCount.value < 24) return 0;
    return Math.floor((spotCount.value - 12) / 12);
  });
  const adIndexes = computed(() => {
    const indexes = [];
    for (let i = 12; i < spotCount.value && indexes.length < adCount.value; i += 12) {
      indexes.push(i);
    }
    return indexes;
  });

  const fetchSpots = async () => {
    isLoading.value = true;
    let data = null;
    
    data = await userStore.getSpotDetailSetByProfile(); // Uses currentProfileId in UserStore

    if (data && data.spots) {
      emit('loaded', data);
    }
    isLoading.value = false;
  };

  watchEffect(() => {
     if (!userStore.initialized) return;

     fetchSpots()
  })

  watch(() => [userStore.currentProfileId, updateKey.key], () => {
    fetchSpots();
  });
  
</script>

<template>
  <div class="jwx-spot-list-container">
    <div v-if="isLoading" class="jwx-spot-list-loader">
      <p>Loading weather stations...</p>
    </div>
    <div v-else-if="userStore.favoriteSpotData.spots.length === 0" class="jwx-p-jumbo">
      <p class="jwx-text jwx-font-size-lg jwx-text-center jwx-m-jumbo">You have no favorited spots.</p>
    </div>
    <SpotList
      v-else
      :data="userStore.favoriteSpotData.spots"
      :showLocalTimestamp="true"
      :adIndexes="adIndexes"
    />
  </div>
</template>
